export const HEADER_TEXT = {
  LOGO_ALT: 'Ocean Breeze Retreat',
  BRAND_NAME: 'OCEAN BREEZE RETREAT',
  APP_NAME: 'GUEST MANAGEMENT',
  DASHBOARD: 'Dashboard',
  NEW_BOOKING: 'New Booking',
  USER_MANAGEMENT: 'User Management',
  CHANGE_PASSWORD: 'Change Password',
  LOGOUT: 'Logout',
} as const;

export const HEADER_TEST_ID = {
  USER_MENU_BUTTON: 'user-menu-btn',
} as const;
